<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="row align-items-center pt-5">
    <strong>Day offs</strong>
    <div class="row">
      <div class="col-3">
        <label for="startDatePicker" required
          >Start date & time<span class="required">*</span></label
        >
        <VueCtkDateTimePicker
          id="startDatePicker"
          v-model="form.startDateTime"
          format="DD/MM/YYYY HH:mm"
          formatted="DD MMM YYYY HH:mm"
          minuteInterval="15"
          :noHeader="true"
          :noLabel="true"
          :class="{
            'input--error': isSubmit && error.errorStartDateTime,
          }"
        />
        <div class="text-error" style="min-height: 1.2em">
          <span v-if="isSubmit && error.errorStartDateTime">
            {{ error.errorStartDateTime.message }}
          </span>
        </div>
      </div>
      <div class="col-3">
        <label for="endDatePicker" required
          >End date & time<span class="required">*</span></label
        >
        <VueCtkDateTimePicker
          id="endDatePicker"
          v-model="form.endDateTime"
          format="DD/MM/YYYY HH:mm"
          formatted="DD MMM YYYY HH:mm"
          minuteInterval="15"
          :noHeader="true"
          :noLabel="true"
          :class="{
            'input--error': isSubmit && error.errorEndDateTime,
          }"
        />
        <div class="text-error" style="min-height: 1.2em">
          <span v-if="isSubmit && error.errorEndDateTime">
            {{ error.errorEndDateTime.message }}
          </span>
        </div>
      </div>
      <div class="col-3 d-flex">
        <div class="p-2 align-self-center">
          <button
            class="btn btn-outline-success"
            style="width: 100%; max-width: 131px"
            @click="onSubmit"
          >
            Add
          </button>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div v-if="showSuccess" class="col-12">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="col-12">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'ServiceMaster' })"
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <div v-if="!showSuccess" class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
    <b-table
      class="table table-responsive table-bordered mt-5"
      hover
      responsive
      :fields="fields"
      :items="dayOffList"
      :per-page="perPage"
      @sort-changed="sortCompare"
    >
      <template #table-caption v-if="dayOffList.length === 0">
        <h5 class="text-center pt-10">There is no day off data</h5>
      </template>
      <template #cell(action)="data">
        <div class="d-flex justify-content-evenly">
          <button
            @click="confirmDelete(data.item.id)"
            class="btn btn-outline-danger"
          >
            Delete
          </button>
        </div>
      </template>
    </b-table>
    <v-dialog v-model="showDeleteDialog" max-width="500">
      <v-card>
        <v-card-title>Delete Confirmation</v-card-title>
        <v-card-text>
          Are you sure you want to delete this day-off record?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue" @click="showDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn text color="red" @click="deleteConfirmed">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <b-pagination
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
      class="my-0"
      aria-controls="my-table"
      @input="changePage"
    ></b-pagination>
  </div>
</template>

<script>
import DefaultListViewData from "@/views/defaultListViewData";
import fields from "./listDayOffFields.json";
import DayOffService from "services/api/dayOff.service";
import moment from "moment";

export default {
  props: {
    resourceId: {
      type: [String, Number],
      required: true,
    },
    resourceType: {
      type: String,
      required: true,
    },
    storeCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ...DefaultListViewData,
      isSubmit: false,
      isLoading: false,
      showSubmit: false,
      showDialog: false,
      showSuccess: false,
      showDeleteDialog: false,
      deleteItemId: null,
      message: null,
      form: {
        startDateTime: null,
        endDateTime: null,
      },
      error: {
        errorStartDateTime: null,
        errorEndDateTime: null,
      },
      dayOffList: [],
      fields,
    };
  },
  async mounted() {
    this.isLoading = true;
    await this.getResourceDayOffs();
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.showSuccess = false;
      this.resetErrorText();

      let hasError = false;

      if (!this.form.startDateTime) {
        this.error.errorStartDateTime = {
          message: "กรุณาเลือกวันและเวลาเริ่มต้น"
        };
        hasError = true;
      }

      if (!this.form.endDateTime) {
        this.error.errorEndDateTime = {
          message: "กรุณาเลือกวันและเวลาสิ้นสุด"
        };
        hasError = true;
      }

      if (hasError) {
        this.isLoading = false;
        return;
      }

      this.createResourceDayOff();
      if (this.isSubmit && !this.error.errorStartDateTime && !this.error.errorEndDateTime) {
        this.form.startDateTime = null;
        this.form.endDateTime = null;
      }
    },
    async getResourceDayOffs() {
      this.isLoading = true;
      const params = this.getParams();
      if (this.resourceType === "ROOM") {
        await DayOffService.getRoomDayOffs(
          this.storeCode,
          this.resourceId,
          params
        )
          .then((res) => {
            this.getDayOffs(res);
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else if (this.resourceType === "STAFF") {
        await DayOffService.getStaffDayOffs(
          this.storeCode,
          this.resourceId,
          params
        )
          .then((res) => {
            this.getDayOffs(res);
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else {
        await this.$router.push({ name: "CounterService" });
      }
    },
    async createResourceDayOff() {
      this.isLoading = true;
      const body = {
        startDateTime: this.convertToISO8601(this.form.startDateTime),
        endDateTime: this.convertToISO8601(this.form.endDateTime),
      };
      if (this.resourceType === "ROOM") {
        await DayOffService.createRoomDayOff(
          this.storeCode,
          this.resourceId,
          body
        )
          .then(() => {
            this.createSuccess();
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else if (this.resourceType === "STAFF") {
        await DayOffService.createStaffDayOff(
          this.storeCode,
          this.resourceId,
          body
        )
          .then(() => {
            this.createSuccess();
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else {
        await this.$router.push({ name: "CounterService" });
      }
    },
    confirmDelete(id) {
      this.deleteItemId = id;
      this.showDeleteDialog = true;
    },
    async deleteConfirmed() {
      this.showDeleteDialog = false;
      if (this.deleteItemId) {
        await this.deleteDayOff(this.deleteItemId);
        this.deleteItemId = null;
      }
    },
    async deleteDayOff(id) {
      this.isLoading = true;
      if (this.resourceType === "ROOM") {
        await DayOffService.deleteRoomDayOff(
          this.storeCode,
          this.resourceId,
          id
        )
          .then(() => {
            console.log("Delete complete.");
            this.getResourceDayOffs();
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else if (this.resourceType === "STAFF") {
        await DayOffService.deleteStaffDayOff(
          this.storeCode,
          this.resourceId,
          id
        )
          .then(() => {
            this.getResourceDayOffs();
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else {
        await this.$router.push({ name: "DetailResourceMaster" });
      }
    },
    getDayOffs(result) {
      this.isLoading = false;
      const data = result.data;
      this.totalItems = data.totalItems;
      this.dayOffList = data.dayOffs.map((item) => ({
        ...item,
        startDateTime: this.convertToDateTimeFormat(item.startDateTime),
        endDateTime: this.convertToDateTimeFormat(item.endDateTime),
      }));
    },
    createSuccess() {
      this.getResourceDayOffs();
    },
    getParams() {
      return {
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "",
        sortType: this.sort.type || "",
      };
    },
    async setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    requestFailure(err) {
      this.isLoading = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
      }
      if (errorData.message) {
        this.message = errorData.message;
      } else {
        this.message = "ไม่สามารถบันทึกได้";
      }
      this.showDialog = true;
    },
    resetErrorText() {
      this.error = {
        errorStartDateTime: "",
        errorEndDateTime: "",
      };
    },
    setErrorText(errors) {
      this.error.errorStartDateTime = errors.find(
        (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDateTime = errors.find(
        (e) => e.fieldName === "endDate"
      );
    },
    convertToISO8601(date) {
      if (!date) {
        return null;
      }
      const parsedDate = moment(date, "DD/MM/YYYY HH:mm", true);
      return parsedDate.utcOffset("+07:00").format("YYYY-MM-DDTHH:mm:ssZ");
    },
    convertToDateTimeFormat(date) {
      if (!date) return null;
      return moment(date).format("DD MMM YYYY HH:mm");
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getResourceDayOffs();
    },
    changePage() {
      this.getResourceDayOffs();
    },
  },
};
</script>
